const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/exercises/new.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/exercises/new.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { CatalogExerciseNotFoundError } from '@/features/workouts/domain/errors';
import { getCatalogExerciseQuery } from '@/features/workouts/lib/get-catalog-exercise.query';
import { listCatalogMusclesQuery } from '@/features/workouts/lib/list-catalog-muscles.query';
const newExerciseSearchSchema = z.object({
  from: z.string().optional().catch(undefined)
});
export const Route = createFileRoute('/_authenticated/resources/exercises/new')({
  validateSearch: newExerciseSearchSchema,
  loaderDeps: ({
    search
  }) => ({
    from: search.from
  }),
  loader: async ({
    context,
    deps: search,
    location
  }) => {
    const deps = {
      controllers: {
        workoutController: context.deps.controllers.workoutController
      },
      validators: {
        exerciseIdValidator: context.deps.validators.exerciseIdValidator
      }
    };
    const validated = deps.validators.exerciseIdValidator.validate(search.from);
    try {
      await context.queryClient.ensureQueryData(listCatalogMusclesQuery(deps));
      if (validated.ok) {
        try {
          await context.queryClient.ensureQueryData(getCatalogExerciseQuery(deps, validated.data));
        } catch (error) {
          if (!(error instanceof CatalogExerciseNotFoundError)) {
            throw error;
          }
        }
      }
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});